import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlService } from '@services/url.service';
import { SelectListItem } from '@shared/models/select-list-item';
import { SystemVendorConfig } from '@shared/models/system-vendor-config.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PharmacyVendorsService {
  private http = inject(HttpClient);
  private urlService = inject(UrlService);

  getPharmacySystemVendors(): Observable<SystemVendorConfig[]> {
    const URL = this.urlService.MASTER_DATA_URL + '/system-vendor-configs/';
    return this.http.get<{ systemVendorConfigs: SystemVendorConfig[] }>(URL).pipe(map(result => result.systemVendorConfigs));
  }

  getSelectListOptions(): Observable<SelectListItem[]> {
    return this.getPharmacySystemVendors().pipe(
      map(options => {
        return options.map(option => ({
          name: option.name ? option.name : option.id,
          value: option.id,
        }));
      }),
    );
  }
}
